/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseClasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.MerchantAccounts {
    "use strict";

    enum MerchantAccountSection {
        Main = 0,
        Devices = 1,
        CareCredit = 2,
        AdminSettings = 3,
        Surcharges = 4,
    }

    enum CheckCardOnFileResponse {
        DeleteMerchantAccount,
        ShowConfirmation,
        Cancel,
    }

    export class MerchantAccountsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        protected isActivating: boolean = false;
        protected activationCode: string = "";
        protected newTerminals: any[] = [];
        protected mainSection = null;

        private isSurchargesEnabled = false;
        private isMeevoPayBalanceEnabled = false;
        private isTippyEnabled = false;

        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Components.Busy.IBusyService,
            protected $cookies: angular.cookies.ICookiesService,
            protected $q: ng.IQService,
            protected $translate: ng.translate.ITranslateService,
            protected hostedPageService: Meevo.Components.HostedPage.IHostedPageService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected roundingService: Meevo.Components.Common.IRoundingService,
            protected tippyService: Meevo.Plugins.Tippy.TippyService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.baseEndpoint = appSettings.API_ENDPOINTS.merchantAccount;
            this.sectionTemplatePath = "app/plugins/merchantAccounts/sectionViews/";
            this.entityType = 'MerchantAccount';
            this.getModuleSecurity();

            this.initializeSections();
        }

        initializeSections() {
            this.addMainSection();
            this.addDeviceSection();
            this.addCareCreditSection();
            this.addAdminSettingsSection();
            this.addSurchargesSection();
            this.addTestConfigSection();
        }

        getModuleSecurity() {
            const surchargeKey = Meevo.Components.Common.SecurityKeys.REGISTER_MERCHANTACCOUNT_TAB_SURCHARGES + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
            this.securityService.checkModuleAccess(surchargeKey).then(moduleAccess =>
                this.isSurchargesEnabled = moduleAccess === Meevo.Model.SecurityAccessEnum.Grant);

            const balanceKey = Meevo.Components.Common.SecurityKeys.MEEVOPAYBALANCE_READ_INTERNAL;
            this.securityService.checkModuleAccess(balanceKey).then(moduleAccess =>
                this.isMeevoPayBalanceEnabled = moduleAccess === Meevo.Model.SecurityAccessEnum.Grant);

            this.tippyService.isTippyConfigured().then(isEnabled => this.isTippyEnabled = isEnabled);
        }

        addMainSection() {
            if (!this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.REGISTER_MERCHANTACCOUNT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                return;
            }

            this.mainSection = new MainSection(
                MerchantAccountSection.Main,
                this,
                "SECTION_MAIN",
                "main.html",
                true,
                false,
                this.appSettings.API_ENDPOINTS.merchantAccount,
                "",
                this.loggingService,
                this.dataService,
                this.identityService,
                Meevo.Model.NounEnum.MerchantAccountMain,
                this.appSettings,
                this.modalService,
                this.securityKeys.REGISTER_MERCHANTACCOUNT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
            );

            this.sections.push(this.mainSection);
        }

        addDeviceSection() {
            if (!this.securityChecker.hasSecurity(this.securityKeys.REGISTER_MERCHANTACCOUNT_TAB_DEVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                return;
            }

            this.sections.push(new DevicesSection(
                MerchantAccountSection.Devices,
                "SECTION_MERCHANTACCOUNT_DEVICES",
                "devices.html",
                false,
                true,
                "",
                "/Devices",
                this.loggingService,
                this.dataService,
                this.identityService,
                Meevo.Model.NounEnum.MerchantAccountDevices,
                this.modalService,
                this.tippyService,
                this.appSettings,
                this.securityKeys.REGISTER_MERCHANTACCOUNT_TAB_DEVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
            );
        }

        addCareCreditSection() {
            if (!this.securityChecker.hasSecurity(this.securityKeys.REGISTER_MERCHANTACCOUNT_TAB_CARECREDIT + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                return;
            }

            this.sections.push(new CareCreditSection(
                MerchantAccountSection.CareCredit,
                "SECTION_MERCHANTACCOUNT_CARECREDIT",
                "carecredit.html",
                false,
                true,
                "",
                "",
                this.loggingService,
                this.dataService,
                this.identityService,
                Meevo.Model.NounEnum.MerchantAccountCareCreditManagePromotions,
                this.modalService,
                this.hostedPageService,
                this.securityKeys.REGISTER_MERCHANTACCOUNT_TAB_CARECREDIT + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
            );
        }

        addAdminSettingsSection() {
            if (!this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.REGISTER_MERCHANTACCOUNT_TAB_ADMINSETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                return;
            }

            if (this.isApplicationModeCO()) {
                return;
            }

            this.sections.push(new AdminSettingsSection(
                MerchantAccountSection.AdminSettings,
                "SECTION_MERCHANTACCOUNT_ADMIN_SETTINGS",
                "adminSettings.template.html",
                false,
                false,
                this.appSettings.API_ENDPOINTS.merchantAccount,
                "adminSettings",
                this.loggingService,
                this.dataService,
                this.identityService,
                Meevo.Model.NounEnum.MerchantAccountAdminSettingsTab,
                this.modalService,
                this.securityKeys.REGISTER_MERCHANTACCOUNT_TAB_ADMINSETTINGS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                this.$translate)               
            );
        }

        addSurchargesSection() {
            this.sections.push(new SurchargesSection(
                MerchantAccountSection.Surcharges,
                'SECTION_MERCHANTACCOUNT_SURCHARGES',
                'surcharges.template.html',
                false,
                false,
                this.appSettings.API_ENDPOINTS.merchantAccount,
                "surcharges",
                this.loggingService,
                this.dataService,
                this.identityService,
                Meevo.Model.NounEnum.MerchantAccountSurchargesTab,
                this.modalService,
                this.securityKeys.REGISTER_MERCHANTACCOUNT_TAB_SURCHARGES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                this.$translate,
                this.roundingService
            ));
        }

        addTestConfigSection() {
            if (!this.identityService.current().systemSettings.isTestingEnvironment) {
                return;
            }

            let allowTestConfig = (this.$cookies.get("AllowTestMerchantAccount") == "1234567890ABCDEFGHIJKLMNOPQRSUVWXYZ");
            if (!allowTestConfig) {
                return;
            }

            this.sections.push(new TestConfigurationSection(1,
                "SECTION_MERCHANTACCOUNT_TEST_CONFIGURATION",
                "testConfiguration.html",
                this.appSettings.API_ENDPOINTS.merchantAccount,
                "TestConfiguration",
                this.loggingService,
                this.dataService,
                this.identityService,
                Meevo.Model.NounEnum.MerchantAccount,
                this.modalService,
                this.securityKeys.REGISTER_MERCHANTACCOUNT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
            );
        }

        selectSection(item): void {
            switch (item.sectionId) {
                case MerchantAccountSection.AdminSettings:
                    this.buildCrudSecurityKeys(this.securityKeys.REGISTER_MERCHANTACCOUNT_TAB_ADMINSETTINGS);
                    break;
                case MerchantAccountSection.Surcharges:
                    this.buildCrudSecurityKeys(this.securityKeys.REGISTER_MERCHANTACCOUNT_TAB_SURCHARGES);
                    break;
                default:
                    this.buildCrudSecurityKeys(this.securityKeys.REGISTER_MERCHANTACCOUNT_TAB_MAIN);
                    break;
            }
            super.selectSection(item);
        }

        initializeHeader(model: any) {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetai;
            let vm = <Meevo.Model.MerchantAccount>model;
            this.addRemoveSections(vm.merchantProviderId);
        }

        postAdd(model: any) {
            let vm = <Meevo.Model.MerchantAccount>model;
            this.addRemoveSections(vm.merchantProviderId);
            super.postAdd(model);
        }

        postUpdate(model: any) {
            let vm = <Meevo.Model.MerchantAccount>model;
            this.addRemoveSections(vm.merchantProviderId);
            super.postUpdate(model);
        }

        preDelete(): ng.IPromise<boolean> {
            return this.checkMerchantAccountUsage().then((conflictExists: boolean) => {
                if (conflictExists) {
                    return this.$q.reject()
                }

                return this.checkTokenMigrationInProgress().then((inProgress: boolean) => {
                    if (inProgress) {
                        return this.$q.reject();
                    }

                    return this.checkCardOnFileUsage()
                        .then((response: CheckCardOnFileResponse) => {
                            switch (response) {
                                case CheckCardOnFileResponse.Cancel:
                                    return this.$q.reject();
                                case CheckCardOnFileResponse.ShowConfirmation:
                                    return this.$q.resolve(true);
                                case CheckCardOnFileResponse.DeleteMerchantAccount:
                                    return this.$q.resolve(false);
                            }
                        })
                        .catch(() => {
                            return this.$q.reject();
                        });
                });
            })
            .then((confirmDelete: boolean) => {
                if (confirmDelete) {
                    return super.preDelete();
                }
            });
        }

        private getRemainingActiveMeevoPayCount(excludeMerchantAccountId: string): ng.IPromise<any> {
            const merchantAccountRequest = {
                criteria: {
                    includeActive: true,
                    includeInactive: true,
                },
                itemsPerPage: 10000,
            };

            return this.dataService.customMethodData(`api/merchantAccount/list`, 'POST', merchantAccountRequest).then((response) => {
                const merchantAccounts = response.data;
                const remainingActiveMerchantAccounts = merchantAccounts.filter(merchantAccount =>
                    this.isMeevoPayProvider(merchantAccount.merchantProviderId) &&
                    merchantAccount.id !== excludeMerchantAccountId &&
                    merchantAccount.objectState === Meevo.Model.ObjectStateEnum.Active);
                return remainingActiveMerchantAccounts.length;
            });
        }

        private checkCardOnFileUsage(): ng.IPromise<CheckCardOnFileResponse> {
            const merchantAccount = this.mainSection.model;
            const merchantAccountId = merchantAccount.id;
            const merchantProviderId = merchantAccount.merchantProviderId;

            const deletePaymentAccounts = (paymentAccountsCount: number): ng.IPromise<CheckCardOnFileResponse> => {
                const parameters = {
                    paymentAccountsCount: paymentAccountsCount,
                };

                const message = this.$translate.instant('MESSAGE_REMOVE_PAYMENT_ACCOUNTS_FROM_MERCHANT_ACCOUNT', parameters);

                const confirmOptions: Meevo.Components.Modal.ILocalOptions = {
                    okButtonContentKey: 'LABEL_YES',
                    cancelButtonContentKey: 'LABEL_CANCEL',
                };

                return this.modalService.redAlertConfirm(
                    message,
                    Components.Modal.ModalTranslationModes.DoNotTranslate,
                    false,
                    confirmOptions)
                    .then(() => {
                        return this.dataService.customMethodData(`api/merchantAccount/${merchantAccountId}/paymentAccount/unlink`, 'POST', {})
                            .then(() => this.$q.resolve(CheckCardOnFileResponse.DeleteMerchantAccount));
                    })
                    .catch(() => this.$q.resolve(CheckCardOnFileResponse.Cancel));
            };

            const reassignPaymentAccounts = (merchantAccounts: Meevo.Model.MerchantAccount[]): ng.IPromise<CheckCardOnFileResponse> => {
                const reassignOptions: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: 'app/plugins/merchantAccounts/reassignPaymentAccounts/reassignPaymentAccountsModal.template.html',
                    controller: 'meevo.plugins.merchantAccounts.ReassignPaymentAccountsModalController',
                    controllerAs: 'vm',
                    bindToController: true,
                    locals: {
                        merchantAccounts: merchantAccounts,
                    }
                };

                return this.modalService.showCustom(reassignOptions)
                    .then((toMerchantAccountId?: string) => {
                        if (!toMerchantAccountId) {
                            return this.$q.resolve(CheckCardOnFileResponse.Cancel);
                        }

                        const reassignRequest = {
                            toMerchantAccountId: toMerchantAccountId
                        };

                        return this.dataService.customMethodData(`api/merchantAccount/${merchantAccountId}/paymentAccount/reassign`, 'POST', reassignRequest)
                            .then(() => this.$q.resolve(CheckCardOnFileResponse.DeleteMerchantAccount));
                    })
                    .catch(() => this.$q.resolve(CheckCardOnFileResponse.Cancel));
            };

            const singleMerchantAccount = (paymentAccountsCount: number): ng.IPromise<CheckCardOnFileResponse> => {
                return this.modalService.yellowConfirm('MESSAGE_PAYMENT_ACCOUNTS_FOR_MERCHANT_ACCOUNT')
                    .then(() => deletePaymentAccounts(paymentAccountsCount));
            };

            const multipleMerchantAccounts = (paymentAccountsCount: number, merchantAccounts: Meevo.Model.MerchantAccount[]): ng.IPromise<CheckCardOnFileResponse> => {
                const reassignOptions: Meevo.Components.Modal.ILocalOptions = {
                    okButtonContentKey: 'LABEL_DELETE_PAYMENT_ACCOUNTS',
                    cancelButtonContentKey: 'LABEL_REASSIGN_PAYMENT_ACCOUNTS',
                    showCancelButton: true,
                };

                return this.modalService.yellowConfirm(
                    'MESSAGE_PAYMENT_ACCOUNTS_FOR_MERCHANT_ACCOUNT_REASSIGN',
                    Components.Modal.ModalTranslationModes.Translate,
                    false,
                    reassignOptions)
                    .then(() => deletePaymentAccounts(paymentAccountsCount))
                    .catch(() => reassignPaymentAccounts(merchantAccounts));
            };

            const merchantAccountRequest = {
                criteria: {
                    merchantAccountProvider: merchantProviderId,
                }
            };

            return this.dataService.customMethodData(`api/merchantAccount/list`, 'POST', merchantAccountRequest).then((response) => {
                const merchantAccounts = response && response.data;

                if (!merchantAccounts || merchantAccounts.length === 0) {
                    // should not happen
                    console.error(`No merchant accounts found for merchant provider ${merchantProviderId}`);
                    return;
                }

                const otherMerchantAccounts = _(merchantAccounts).filter(merchantAccount => merchantAccount.id != merchantAccountId);

                return this.dataService.customMethodData(`api/merchantAccount/${merchantAccountId}/paymentAccount/count`, 'GET', {}).then((response) => {
                    const paymentAccountsCount = response.data;

                    // no payment accounts found - fallback to regular delete merchant account confirm
                    if (paymentAccountsCount === 0) {
                        return this.$q.resolve(CheckCardOnFileResponse.ShowConfirmation);
                    }

                    return otherMerchantAccounts.length === 0
                        ? singleMerchantAccount(paymentAccountsCount)
                        : multipleMerchantAccounts(paymentAccountsCount, otherMerchantAccounts);
                });
            });
        }

        checkTokenMigrationInProgress(): ng.IPromise<boolean> {
            const merchantAccount = this.mainSection.model;
            const merchantAccountId = merchantAccount.id;
            const merchantProviderId = merchantAccount.merchantProviderId;

            // only check token migration status for merchant accounts that can create tokens
            if (!merchantAccount.canCreateTokens) {
                return this.$q.resolve(false);
            }

            const continueTokenMigrationStatusCheck = (message: string) => {
                return this.getTokenMigrationInProgress(merchantAccountId, merchantProviderId, message).then((inProgress) => {
                    return this.$q.resolve(inProgress);
                });
            }

            if (this.isMeevoPayProvider(merchantProviderId)) {
                return this.getRemainingActiveMeevoPayCount(merchantAccountId).then((count) => {
                    // allow delete if there is at least one remaining active MeevoPay account
                    if (count >= 1) {
                        return this.$q.resolve(false);
                    }

                    return continueTokenMigrationStatusCheck("MESSAGE_MERCHANT_ACCOUNT_MEEVOPAY_CANNOT_REMOVE");
                });
            }

            return continueTokenMigrationStatusCheck("MESSAGE_CANNOT_DELETE_MERCHANT_ACCOUNT_MIGRATION_IN_PROGRESS");
        }

        private getTokenMigrationInProgress(merchantAccountId: string, merchantProviderId: number, message: string): ng.IPromise<boolean> {
            const isTokenMigrationInProgress = (tokenMigrationStatus): boolean => {
                const inProgress = tokenMigrationStatus.importStatus !== Meevo.Model.ImportStatusEnum.Void
                    && tokenMigrationStatus.importStatus !== Meevo.Model.ImportStatusEnum.Published
                    && tokenMigrationStatus.importStatus !== undefined;

                if (!inProgress) {
                    return false;
                }

                // MeevoPay is not a migration source, so don't perform merchant account check
                if (this.isMeevoPayProvider(merchantProviderId)) {
                    return true;
                }

                if (tokenMigrationStatus.merchantAccountIds.length === 0) {
                    return true;
                }

                if (!tokenMigrationStatus.merchantAccountIds.some(tokenMigrationMerchantAccount => tokenMigrationMerchantAccount === merchantAccountId)) {
                    return false;
                }

                return true;
            };

            return this.dataService.customMethodData(`api/tokenMigration/status`, 'GET', {}).then((tokenMigrationStatusResponse) => {
                if (isTokenMigrationInProgress(tokenMigrationStatusResponse.data)) {
                    return this.modalService.alert(message).then(() => {
                        return true;
                    });
                }

                // if CO doesn't exist, then don't check multi-location token migration status
                const centralOfficeId = this.identityService.current().centralOfficeId;
                if (!centralOfficeId) {
                    return false;
                }

                // check multi-location token migration status
                return this.dataService.customMethodData(`api/tokenMigration/status?isMultiLocationOverride=true`, 'GET', {}).then((tokenMigrationStatusResponse) => {
                    const locations = tokenMigrationStatusResponse.data.locations;
                    const hasLocation = locations && locations.some((locationId: number) => locationId === this.identityService.current().locationId);

                    if (hasLocation && isTokenMigrationInProgress(tokenMigrationStatusResponse.data)) {
                        return this.modalService.alert(message).then(() => {
                            return true;
                        });
                    }

                    return false;
                });
            });
        }

        private checkOnlineMembership(merchantAccountId) {
            if (!this.securityChecker.hasSecurity(this.securityKeys.REGISTER_MERCHANTACCOUNT_ONLINEMEMBERSHIP_INTERNAL + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                return this.$q.resolve(false);
            }

            return this.dataService.getItem("settings/onlineMembership").then(resp => {
                const settings = resp as Model.OnlineMembershipSettings;
                const isOnlineMembershipConflict = merchantAccountId == settings.merchantAccount;

                if (isOnlineMembershipConflict) {
                    return this.modalService.warning("MESSAGE_DELETE_INACTIVATE_MERCHANT_ACCOUNT_ONLINE_MEMBERSHIP")
                        .then(() => {
                            return true;
                        });
                }
                return false;
            })
        }

        private checkMerchantAccountUsage(): ng.IPromise<boolean> {
            const merchantAccountId = this.mainSection.model.id;
            return this.checkOnlineMembership(merchantAccountId).then(isConflict => {
                if (isConflict)
                    return true;
                else {
                    const settings = [
                        this.dataService.getItem(`eGift/settings`),
                        this.dataService.getItem(`settings/membership`),
                    ];

                    return this.$q.all(settings).then((results) => {
                        const egiftSettings = results[0] as Model.IEGiftsSettings;
                        const membershipSettings = results[1] as Model.MembershipSettings;

                        const isEGiftConflict = egiftSettings.settings.enableEGifts &&
                            merchantAccountId == egiftSettings.settings.paymentProcessingPreferences;
                        const isMembershipConflict = merchantAccountId == membershipSettings.defaultMerchantAccount;

                        if (!isEGiftConflict && !isMembershipConflict) {
                            return this.$q.resolve(false);
                        }

                        const messages = [
                            this.$translate.instant('LABEL_MERCHANT_ACCOUNT_USED'),
                            ""
                        ];

                        if (isEGiftConflict) {
                            messages.push(this.$translate.instant('LABEL_MERCHANT_ACCOUNT_USED_BY_EGIFT'));
                        }

                        if (isMembershipConflict) {
                            messages.push(this.$translate.instant('LABEL_MERCHANT_ACCOUNT_USED_BY_MEMBERSHIP'));
                        }
                        const message = messages.join('<br>');

                        return this.modalService.alert(message, Components.Modal.ModalTranslationModes.DoNotTranslate)
                            .then(() => this.$q.resolve(true));
                    });
                }
            });
        }

        postDelete() {
            super.postDelete();
            this.addRemoveSections(this.castModel<Meevo.Model.MerchantAccount>().merchantProviderId, true);
        }

        postUndelete() {
            super.postUndelete();
            this.addRemoveSections(this.castModel<Meevo.Model.MerchantAccount>().merchantProviderId, false);
        }

        private isDeviceSectionHidden(merchantProviderId: Meevo.Model.MerchantAccountProviderEnum): boolean {
            switch (merchantProviderId) {
                case Model.MerchantAccountProviderEnum.VantivGC:
                case Model.MerchantAccountProviderEnum.CareCredit:
                case Model.MerchantAccountProviderEnum.ConnectE:
                    return true;
            }

            return false;
        }

        private isCareCreditSectionHidden(merchantProviderId: Meevo.Model.MerchantAccountProviderEnum): boolean {
            return merchantProviderId !== Model.MerchantAccountProviderEnum.CareCredit;
        }

        private isAdminSettingsSectionHidden(merchantProviderId: Meevo.Model.MerchantAccountProviderEnum): boolean {
            return merchantProviderId && !this.isMeevoPayProvider(merchantProviderId);
        }

        private isSurchargesSectionHidden(merchantProviderId: Meevo.Model.MerchantAccountProviderEnum): boolean {
            return merchantProviderId && !this.isMeevoPayProvider(merchantProviderId);
        }

        private addRemoveDeviceSection(merchantProviderId: Meevo.Model.MerchantAccountProviderEnum, forceSectionRemoval: boolean) {
            // Omit the Devices section when deleted or hidden for provider
            if (forceSectionRemoval || this.isDeviceSectionHidden(merchantProviderId)) {
                this.sections = _.reject(this.sections, (section: any) => section instanceof DevicesSection);
            } else {
                if (!_.some(this.sections, (section: any) => section instanceof DevicesSection)) {
                    this.addDeviceSection();
                }
            }
        }

        private addRemoveCareCreditSection(merchantProviderId: Meevo.Model.MerchantAccountProviderEnum, forceSectionRemoval: boolean) {
            // Omit the CareCredit section when deleted or hidden for provider
            if (forceSectionRemoval || this.isCareCreditSectionHidden(merchantProviderId)) {
                this.sections = _.reject(this.sections, (section: any) => section instanceof CareCreditSection);
            } else {
                if (!_.some(this.sections, (section: any) => section instanceof CareCreditSection)) {
                    this.addCareCreditSection();
                }
            }
        }

        private addRemoveAdminSettingsSection(merchantProviderId: Meevo.Model.MerchantAccountProviderEnum, forceSectionRemoval: boolean) {
            // Omit the Admin & Settings section when deleted or hidden for provider
            if (forceSectionRemoval || this.isAdminSettingsSectionHidden(merchantProviderId)) {
                this.sections = _.reject(this.sections, (section: any) => section instanceof AdminSettingsSection);
            } else {
                if (!_.some(this.sections, (section: any) => section instanceof AdminSettingsSection)) {
                    this.addAdminSettingsSection();
                }
            }
        }

        private addRemoveSurchargesSection(merchantProviderId: Meevo.Model.MerchantAccountProviderEnum, forceSectionRemoval: boolean) {
            // Omit the Admin & Settings section when deleted or hidden for provider
            if (forceSectionRemoval || this.isSurchargesSectionHidden(merchantProviderId) || !this.isSurchargesEnabled) {
                this.sections = _.reject(this.sections, (section: any) => section instanceof SurchargesSection);
                return;
            }

            if (!_(this.sections).some((section: any) => section instanceof SurchargesSection)) {
                this.addSurchargesSection();
            }
        }

        private addRemoveTestingSection(merchantProviderId: Meevo.Model.MerchantAccountProviderEnum, forceSectionRemoval: boolean) {
            if (forceSectionRemoval || (merchantProviderId &&
                merchantProviderId !== Model.MerchantAccountProviderEnum.MeevoPay &&
                merchantProviderId !== Model.MerchantAccountProviderEnum.MeevoPayCanada &&
                merchantProviderId !== Model.MerchantAccountProviderEnum.Worldpay &&
                merchantProviderId !== Model.MerchantAccountProviderEnum.CardConnect &&
                merchantProviderId !== Model.MerchantAccountProviderEnum.CareCredit)) {
                this.sections = _.reject(this.sections, (section: any) => section instanceof TestConfigurationSection);
            } else {
                if (!_.some(this.sections, (section: any) => section instanceof TestConfigurationSection)) {
                    this.addTestConfigSection();
                }
            }
        }

        addRemoveSections(merchantProviderId: Meevo.Model.MerchantAccountProviderEnum, forceSectionRemoval: boolean = false) {
            this.addRemoveDeviceSection(merchantProviderId, forceSectionRemoval);
            this.addRemoveCareCreditSection(merchantProviderId, forceSectionRemoval);
            this.addRemoveAdminSettingsSection(merchantProviderId, forceSectionRemoval);
            this.addRemoveSurchargesSection(merchantProviderId, forceSectionRemoval);
            this.addRemoveTestingSection(merchantProviderId, forceSectionRemoval);
        }

        undelete(activate = false) {
            super.undelete(true);
        }

        get showCopy(): boolean {
            return false;
        }

        get showEdit(): boolean {
            return !this.isApplicationModeCO() && super.showEditLogic();
        }

        // TODO: is this method used anywhere?
        toggleActivate(isActive: boolean) {
            if (!isActive) {
                this.activationCode = "";
            }
            this.isActivating = isActive;
        }

        createNewDevice() {
            if (!this.hasTerminalSupport()) {
                return this.modalService.alert('LABEL_NO_PHYSICAL_TERMINAL_SUPPORT').then(() => {
                    return this.$q.reject();
                });
            }

            if (this.isApplicationModeCO()) {
                return this.$q.resolve();
            }

            const main = this.mainSection;
            if (main && main.model && main.model.canListAvailableTerminals) {
                return this.dataService.customMethodData(`api/MerchantAccount/${this.itemId}/NewTerminals`, 'GET', null)
                    .then((response: any) => {
                        if (response.status == 409) { // conflict
                            return this.modalService.alert(response.data.responseStatus.message);
                        }

                        this.newTerminals = response.data.merchantTerminals.map(terminal => ({
                            serialNumber: terminal.serialNumber,
                            externalTerminalId: terminal.externalTerminalId,
                        }));
                    })
                    .finally(() => {
                        return this.dataService.getTemplate(this.baseEndpoint, this.itemId, "devices");
                    });
            } else {
                return this.dataService.getTemplate(this.baseEndpoint, this.itemId, "devices");
            }
        }

        getDeleteSharedConfirmation = (item: any): string => {
            return item.isShared && this.isWorldpay() ? "MESSAGE_DEVICE_SHARED_DELETE_CONFIRMATION" : null;
        }

        isWorldpay(): boolean {
            const main = this.mainSection;
            return main && main.isWorldpayProvider(main.model.merchantProviderId);
        }

        isCardConnect(): boolean {
            const main = this.mainSection;
            return main && main.isCardConnect(main.model.merchantProviderId);
        }

        isPaymentSense(): boolean {
            const main = this.mainSection;
            return main && main.isPaymentSense(main.model.merchantProviderId);
        }

        isConnectE(): boolean {
            const main = this.mainSection;
            return main && main.isConnectE(main.model.merchantProviderId);
        }

        isCareCredit(): boolean {
            const main = this.mainSection;
            return main && main.isCareCredit(main.model.merchantProviderId);
        }

        isMeevoPayProvider(providerId: number): boolean {
            if (providerId === undefined && this.mainSection.model) {
                providerId = this.mainSection.model.merchantProviderId;
            }
            if (providerId === undefined) {
                return false;
            }
            return this.isMeevoPay(providerId) || this.isMeevoPayCanada(providerId);
        }

        isMeevoPay(providerId: number): boolean {
            return providerId === Meevo.Model.MerchantAccountProviderEnum.Adyen;
        }

        isMeevoPayCanada(providerId: number): boolean {
            return providerId === Meevo.Model.MerchantAccountProviderEnum.AdyenCanada;
        }

        hasSharedTerminalSupport(): boolean {
            const main = this.mainSection;
            return main && main.selectedProvider && main.selectedProvider.hasSharedTerminalSupport;
        }

        hasTerminalDisplaySupport(): boolean {
            const main = this.mainSection;
            return main && main.selectedProvider && main.selectedProvider.hasTerminalDisplaySupport;
        }

        hasTerminalSupport(): boolean {
            const main = this.mainSection;
            return main && main.selectedProvider && main.selectedProvider.hasTerminalSupport;
        }

        isDeviceLogoVisible(device): boolean {
            if (!device || !this.isMeevoPayProvider(device.merchantProviderId)) {
                return false;
            }
            if (this.isSFO1Device(device)) {
                return false;
            }
            return true;
        }

        isSFO1Device(device): boolean {
            return !!device && !!device.externalTerminalId && device.externalTerminalId.substring(0, 4) === "SFO1";
        }

        isTippyKioskIdVisible(device): boolean {
            return this.isTippyEnabled
                && !!device
                && this.appSettings.APP_BUSINFOSETTINGS.registerSettings.enableDualLockBehavior !== false
                && this.isMeevoPayProvider(device.merchantProviderId)
                && this.isSFO1Device(device);
        }

        addDeviceLogo(device) : void {
            let options = {
                templateUrl: "app/plugins/merchantAccounts/deviceLogo/deviceLogoUploadModal.template.html",
                controller: "meevo.plugins.merchantAccounts.DeviceLogoUploadModalController",
                controllerAs: "vm",
                skipHide: true,
                multiple: true,
                locals: {
                    device: device
                }
            };
            this.modalService.showCustom(options);
        }

        deleteDeviceLogo(device): void {
            this.modalService.warning("MESSAGE_DELETE_CONFIRMATION", Components.Modal.ModalTranslationModes.Translate, true,
                {
                    showCancelButton: true,
                    okButtonContentKey: "LABEL_YES",
                    cancelButtonContentKey: "LABEL_NO"
                }).then(() => {
                this.dataService.customMethodData(`api/merchantTerminal/${device.id}/logo`, "DELETE", device).then(() => {
                    device.logo = null;
                });
            });
        }

        getDeviceLogo(deviceListItem) {
            if (!deviceListItem || !this.isMeevoPayProvider(deviceListItem.merchantProviderId)) {
                return this.$q.resolve();
            }

            return this.dataService.customMethodData(`api/merchantTerminal/${deviceListItem.id}/logo?merchantAccountId=${deviceListItem.merchantAccountId}`,
                "GET", {}).then((response) => {
                    //Always using gif since we don't have the image type stored and having a static type works
                    deviceListItem.logo = response.data.logo ? `data:image/gif;base64,${response.data.logo}` : null;
                }).catch((reason) => {
                    console.debug('Device logo fetch failed: ' + angular.toJson(reason));
                    deviceListItem.logo = null;
                });
        }

        isTerminalEditable(terminal): boolean {
            let isEditable: boolean = false;
            if (terminal) {
                const main = this.mainSection;
                if (main) {
                    isEditable = (main.model.id === terminal.merchantAccountId);
                }
            }
            return isEditable;
        }

        validateSave() {
            if (this.selectedSection.sectionId === MerchantAccountSection.Main) {
                const mainSection = this.mainSection;
                let promise = this.$q.resolve(false);
                if (this.mode === Meevo.Model.MaintenanceFormState.Editing &&
                    mainSection.model.objectState === Meevo.Model.ObjectStateEnum.Inactive &&
                    mainSection.backup.objectState === Meevo.Model.ObjectStateEnum.Active) {
                    promise = this.checkOnlineMembership(this.mainSection.model.id);
                }

                return promise.then((isConflict: boolean) => {
                    if (isConflict) {
                        return false;
                    }

                    mainSection.portAccessUrlProtocolTypeChanged();
                    mainSection.setSignaturePromptThresholdAmount();

                    if (!mainSection.checkValidationErrors()) {
                        return false;
                    }
                    return true;
                })
            }
            return this.$q.resolve(true);
        }

        save(): angular.IPromise<any> {
            if (this.selectedSection.sectionId === MerchantAccountSection.AdminSettings) {
                return this.saveAdminSettings().finally(() => {
                    this.busyService.stop();
                });
            } else {
                return this.validateSave().then(isValid => {
                    if (!isValid) {
                        return;
                    }

                    return super.save().finally(() => {
                        this.busyService.stop();
                    });
                })
            }

        }

        saveAdminSettings(): angular.IPromise<any> {

            if (!this.canSave || this.saveInProgress)
                return;

            this.selectedSection.preSave();
            this.selectedSection.preSaveModel = jQuery.extend(true, {}, this.selectedSection.model);

            this.loadingInProgress = true;
            this.saveInProgress = true;

            var updateModel = this.selectedSection.model;

            let baseEndpoint = Model.Guard.isSomething(this.selectedSection.baseEndpoint) ? this.selectedSection.baseEndpoint : this.baseEndpoint;
            return this.dataService.update(baseEndpoint, updateModel, this.itemId, this.selectedSection.sectionEndpoint, this.asLocationId)
                .then((data: any) => {
                    const hasErrors = (data && data.errors && data.errors.length > 0);

                    const adminSection = this.selectedSection as AdminSettingsSection;
                    adminSection.applyPartialSave(data, hasErrors);

                    if (!hasErrors)
                        this.setMode(Model.MaintenanceFormState.Readonly);

                    this.loggingService.trace(`Updates saved.`);
                    this.loadingInProgress = false;
                    this.saveInProgress = false;
                }).catch((reason: any) => {
                    this.loggingService.trace('Item not saved due to error: ' + angular.toJson(reason));
                    this.loadingInProgress = false;
                    this.saveInProgress = false;
                });
        }

        handleWarningsConfirm(warnings: any[]): ng.IPromise<boolean> {
            var message = "";
            for (let warning of warnings) {
                message += this.$translate.instant(warning.message) + '<br/>';
            }
            message += '<br/>' + this.$translate.instant('MESSAGE_CONTINUE');

            return this.modalService.yellowConfirm(message, Components.Modal.ModalTranslationModes.DoNotTranslate);
        }

        activateDevice() {
        }

        isMeevoPayBalanceModuleEnabled(): boolean {
            return this.isMeevoPayBalanceEnabled;
        }
    }
}